// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import {
  Box,
  Button,
  Flex,
  Link,
  Typography,
  useMobileMediaQuery,
} from '@iheartjane/reefer';
import type { ColorKey } from '@iheartjane/reefer';
import { useState } from 'react';

import { PROMPTS } from '@jane/shared-ecomm/hooks';
import { useAuthentication } from '@jane/shared-ecomm/providers';
import { useShouldShowGold } from '@jane/shared/hooks';

import { LogInModal } from '../logInModal/logInModal';
import { Prompt } from '../prompt/prompt';

const NoWrapButton = styled(Button)({
  whiteSpace: 'nowrap',
});

const NoWrapLink = styled(Link)({
  whiteSpace: 'nowrap',
  padding: '12px',
});

interface HeaderSignInPromptProps {
  color?: ColorKey;
  onSignInCancel?: () => void;
  onSignInClick?: () => void;
}

export const HeaderSignInPrompt = ({
  color = 'text-main',
  onSignInCancel,
  onSignInClick,
}: HeaderSignInPromptProps) => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const janeGold = useShouldShowGold();
  const isMobile = useMobileMediaQuery({});
  const { defaultLogin, register, resetPassword, ...authProps } =
    useAuthentication();

  const handleSignInClick = () => {
    onSignInClick && onSignInClick();
    setShowLoginModal(true);
  };

  const handleSignInCancel = () => {
    onSignInCancel && onSignInCancel();
    setShowLoginModal(false);
  };

  const goldText =
    'Sign in to earn cash back and:discover products just for you';
  const nonGoldText = 'Sign in to see personalized:recommendations for you';
  const text = janeGold ? goldText : nonGoldText;

  return (
    <>
      <Prompt
        prompt={PROMPTS.signIn}
        dismissible
        target={
          <NoWrapLink
            color={color}
            onClick={() => handleSignInClick()}
            variant="minimal"
            typography="body-bold"
            branded
          >
            Sign in
          </NoWrapLink>
        }
      >
        <Prompt.Content>
          <Flex
            flexDirection="row"
            gap={16}
            width="100%"
            justifyContent="center"
            alignItems="center"
          >
            {!isMobile && (
              <Box>
                <Typography whiteSpace="nowrap" variant="mini">
                  {text.split(':')[0]}
                </Typography>
                <Typography whiteSpace="nowrap" variant="mini">
                  {text.split(':')[1]}
                </Typography>
              </Box>
            )}

            <NoWrapButton label="Sign in" onClick={() => handleSignInClick()} />
          </Flex>
        </Prompt.Content>
      </Prompt>
      {showLoginModal && (
        <LogInModal
          {...authProps}
          location="header"
          onSignInSubmit={defaultLogin}
          onCreateAccountSubmit={register}
          onForgotPasswordSubmit={resetPassword}
          open
          onRequestClose={() => handleSignInCancel()}
        />
      )}
    </>
  );
};
